export function filterNull<T>(
  items: Record<string, T | null | undefined>
): Record<string, T>;
export function filterNull<T>(items: (T | null | undefined)[]): T[];
export function filterNull<T>(
  items: (
    Record<string, T | null | undefined>
    | (T | null | undefined)[]
  )
): Record<string, T> | T[] {
  if (items instanceof Array) {
    return items.filter((item) => {
      return item != null;
    }) as T[];
  }

  return Object.fromEntries(
    Object.entries(items).filter(([_key, value]) => {
      return value != null;
    })
  ) as Record<string, T>;
}
